var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 3.33333C2.30154 3.33333 2.00002 3.63486 2.00002 4V12C2.00002 12.3651 2.30154 12.6667 2.66669 12.6667H13.3334C13.6985 12.6667 14 12.3651 14 12V4C14 3.63486 13.6985 3.33333 13.3334 3.33333H2.66669ZM0.666687 4C0.666687 2.89848 1.56516 2 2.66669 2H13.3334C14.4349 2 15.3334 2.89848 15.3334 4V12C15.3334 13.1015 14.4349 14 13.3334 14H2.66669C1.56516 14 0.666687 13.1015 0.666687 12V4Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787195 3.61767C0.998338 3.31603 1.41403 3.24268 1.71566 3.45382L8.00002 7.85287L14.2844 3.45382C14.586 3.24268 15.0017 3.31603 15.2128 3.61767C15.424 3.9193 15.3506 4.33499 15.049 4.54613L8.38232 9.2128C8.15278 9.37348 7.84725 9.37348 7.61771 9.2128L0.951042 4.54613C0.649409 4.33499 0.576052 3.9193 0.787195 3.61767Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8b9e9e2d6d68fcec45a1bcb412ca9cae.svg";
export { ForwardRef as ReactComponent };